/**
 * @file
 * Sodexo Main menu functionality
 */

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.mainmenuBlock = {
    attach: function (context, settings) {
      $("#block-mainmenu>.menu").addClass("slimmenu mainnav-menu");

      $("#block-mainmenu ul.menu").each(function () {
        var depth = $(this).parents("ul").length;
        $(this).addClass("level-" + depth);
      });

      $("#block-mainmenu>.menu").slimmenu({
        resizeWidth: "939",
        collapserTitle: "Main Menu",
        animSpeed: "fast",
        easingEffect: null,
        indentChildren: false
      });

      var $block = $("#block-mainmenu"),
        $collapser = $(".menu-collapser", $block),
        $menu = $(".mainnav-menu", $block),
        opened = false;

      $collapser.click(function () {
        $collapser.toggleClass("open");
        $menu.toggleClass("mobile-menu-open").trigger("collapseChange");
        if (!opened) {
          $("li.menu-item--active-trail", $menu)
            .addClass("active-trail-open")
            .trigger("classChange")
            .children("ul")
            .addClass("mobile-menu-open")
            .show();
          opened = true;
        }
        // Also add mobile class to search wrapper
        $(".main-navigation--main--wrapper--right").toggleClass("mobile-search-open").trigger("classChange");
      });

      // Add active-toggle class to sub-toggle
      $(".menu-item--active-trail.has-submenu").each(function () {
        $(".menu-item--active-trail.has-submenu>a.is-active")
          .siblings(".sub-toggle")
          .addClass("expanded active-toggle");
      });

      // Also add inactive toggle for active trail
      $(".menu-item--active-trail.has-submenu").on("classChange", function () {
        if (
          $(".menu-item--active-trail.has-submenu").hasClass(
            "active-trail-open"
          )
        ) {
          $(".menu-item--active-trail.has-submenu>.sub-toggle").addClass(
            "expanded inactive-toggle"
          );
        }
      });

      // Add language switch to mobile menu
      $(window).on("resize load", function () {
        if ($(window).width() < 940) {
          $('#block-languageswitcher').each(function () {
            $('#block-languageswitcher').appendTo($('#block-mainmenu ul.mainnav-menu'));
          });
        } else {
          $('#block-languageswitcher').each(function () {
            $('#block-languageswitcher').appendTo($('.main-navigation--main--wrapper--right--lang-switch'));
          });
        }
      }).resize();

      // Sticky main nav only when scrolling up
      var mainnav = $('.main-navigation');
      var currentScrollY = 0;
      var lastTogledScrollY = 0;

      $(window).scroll(function() {
        currentScrollY = window.pageYOffset;

        if (currentScrollY > lastTogledScrollY+20) {
          mainnav.addClass('hide');
          lastTogledScrollY = currentScrollY;
        }
        else if (currentScrollY < lastTogledScrollY-20) {
          lastTogledScrollY = currentScrollY;
          mainnav.removeClass('hide');
        }
      });

    }
  };
})(jQuery, Drupal);
